module.exports = __webpack_public_path__ + "static/media/chat06.b4551b55.svg";